import { ChangeDetectionStrategy, Component, effect, inject } from "@angular/core";
import { StrategyPageService } from "../strategy-page.service";
import { AudienceStatsComponent } from "@m19-board/strategies/strategies/audience-stats/audience-stats.component";

@Component({
  selector: "app-strategy-page-audience-stats",
  imports: [AudienceStatsComponent],
  template: `@if (strategy(); as strategy) {
    <app-audience-stats [strategy]="strategy" />
  }`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageAudienceStatsComponent {
  private readonly strategyPageService = inject(StrategyPageService);

  strategy = this.strategyPageService.strategy;
}
